import script from "./member-savings-report.vue?vue&type=script&setup=true&lang=js"
export * from "./member-savings-report.vue?vue&type=script&setup=true&lang=js"

import "./member-savings-report.vue?vue&type=style&index=0&id=67dc9ac9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67dc9ac9"]])

export default __exports__